module.exports = __webpack_public_path__ + "assets/e3feaff3eaf167eba5ef134dddd784f1.png";